'use strict';

var responsiveStyle = require('./responsive-style');
module.exports = responsiveStyle('flex');


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/flex.js
// module id = 376
// module chunks = 168707334958949